var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.whereFrom == 1 ? _vm.bottomList1 : _vm.bottomList},_vm._l((_vm.typeList),function(item,index){return _c('div',{key:index,staticClass:"cASSfo sc-963fcq-2 cMEgnO",attrs:{"id":item.type},on:{"click":function($event){return _vm.classClick(item.type)}}},[_c('img',{attrs:{"src":item.iconUrl,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }